import { useSelector } from 'react-redux';
const CryptoJS = require('crypto-js');

const ApiEncrypt = () => {
  const { encryptionValue } = useSelector((state) => state.key);

  const encrypt = (word, stringify = true) => {
    console.log('encryptionValue--@', encryptionValue);
    let encrypted = '';
    const key = CryptoJS.enc.Utf8.parse(encryptionValue.SymmetricKey); //16
    const data = stringify ? JSON.stringify(word) : word;
    const srcs = CryptoJS.enc.Utf8.parse(data);
    encrypted = CryptoJS.AES.encrypt(srcs, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });

    return encrypted.toString();
  };

  return {
    encryptData: encrypt,
  };
};

export default ApiEncrypt;
